import { z } from "zod"

const positiveNumeric = (label) => z.string()
  .trim()
  .min(1, `${label} is required`)
  .regex(/^\d+$/, `${label} must contain numbers only`)
  .refine((v) => Number(v) > 0, `${label} must be greater than 0`)

const nonNegativeNumeric = (label) => z.string()
  .trim()
  .min(1, `${label} is required`)
  .regex(/^\d+$/, `${label} must contain numbers only`)
  .refine((v) => Number(v) >= 0, `${label} must be 0 or greater`)

export const targetSchema = z.object({
  targetMonthlyCashflowGross: nonNegativeNumeric("Target monthly cashflow"),
  timeframeYears: positiveNumeric("Timeframe"),
  availableCapital: nonNegativeNumeric("Available capital"),
  jvCapitalAccess: nonNegativeNumeric("JV capital"),
})
